
class CompetitionDetail{
    defaultOptions() {
        return {
        	'$container': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onFilterChange = this.onFilterChange.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
        	window.notify("$container is missing in component/row/CompetitionDetail","error");
        }

        this.$form = $('.competition-result-form',this.$container);
        this.$filterEpreuve = $('select[name="epreuve"]',this.$form);
        this.$filterCategorie = $('select[name="categorie"]',this.$form);

        this.currentOffset = 0;

        this.initialize();
    }


    initialize(){
    	var self = this;

		this.$filterEpreuve.on('change',this.onFilterChange);
		if(this.$filterCategorie.length > 0){
			this.$filterCategorie.on('change',this.onFilterChange);
		}
    }

    onFilterChange(event){
    	let $filter = $(event.target);

		this.$form.trigger('submit');
    }

}

module.exports = CompetitionDetail;